<template>
    <div>
      <div class="modal-window" :class="{'open': how_to_guide_enquiry_box_open}" @click="how_to_guide_enquiry_box_open = false">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="how_to_guide_enquiry_box_open = false">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h1 class="modal-title">"How to" guide request</h1>
          </div>
          <div class="modal-content">
            <div class="form-group">
              Please enter details of your request below.
            </div>
            <textarea rows="5" v-model="how_to_guide_enquiry_message" class="form-control"></textarea>
          </div>
          <div class="modal-footer align-right">
            <a class="btn-primary" @click="sendHowToGuideEnquiry()">
              Send
            </a>
          </div>
        </div>
      </div>
        <div class="modal-window" :class="{'open': forward_download_box_open}" @click="forward_download_box_open = false">
          <div class="modal-window-inner" @click.stop>
            <div class="modal-close" @click.stop="forward_download_box_open = false">
              <i class="fal fa-times"></i>
            </div>
            <div class="modal-header">
              <h1 class="modal-title">Forward This Item</h1>
            </div>
            <div class="modal-content">
              <p>
                Enter an email address to forward this item to. Please note they will need an account on Connect in order to view and download the item.
              </p>
              <div class="form-group">
                <label>Email</label>
                <input type="text" v-model="forwarding_email" class="form-control">
              </div>
            </div>
            <div class="modal-footer align-right">
              <a class="btn-primary" @click="sendForwardDownloadEmail()">
                Send
              </a>
            </div>
          </div>
      </div>
      <div class="loading-spinner-outer" v-if="sending_how_to_guide_enquiry || sending_forward_download_email">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="modal-window" :class="{'open': video_box_open}" @click="video_box_open = false" v-if="video_box_open">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="video_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">{{ open_video.name }}</h1>
                </div>
                <div class="modal-content mb-6">
                  <div class="align-center">
                    <video-embed :src="open_video.file_url"></video-embed>
                    <div class="mt-2 p-3">
                      <a class="btn-primary" @click="downloadItem(open_video.id)">
                        <strong>Download</strong>
                      </a>
                    </div>
                  </div>
                </div>
            </div>
        </div>
      <div class="modal-window" :class="{'open': file_box_open}" @click="file_box_open = false, open_file = {}" v-if="file_box_open">
        <div class="modal-window-inner" @click.stop>
          <div class="modal-close" @click.stop="file_box_open = false, open_file = {}">
            <i class="fal fa-times"></i>
          </div>
          <div class="modal-header">
            <h3 class="m-0">{{ open_file.name }}</h3>
          </div>
          <div class="modal-content mb-6">
            <div class="align-center">
              <div>
                <img :src="`${$aws_bucket_url}${open_file.thumbnail_url}`" @error="imageFallbackIcon" class="m-a" style="max-height: 200px;">
              </div>
              <div>
                <div class="mt-2 p-3">
                  <a class="btn-primary" @click="downloadItem(open_file.id)">
                    <strong>Download</strong>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="loading-spinner-outer" v-if="loading">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
            </div>
        </div>
        <div class="transparent-overlay" @click="tag_dropdown_open = false" v-if="tag_dropdown_open"></div>
        <div class="page-title pt-0">
                <div class="justify-end" :class="{ 'flex-sm' : user_can_manage_downloads, 'flex-xs' : !user_can_manage_downloads}">
                    <div class="justify-end flex-xs" :class="{ 'pb-1 pb-0-sm' : user_can_manage_downloads }">
                        <div class="pr-1-xs" v-if="!list_view">
                            <a class="btn-primary full-width" @click.stop="list_view = true">List View</a>
                        </div>
                        <div class="pr-1-xs" v-if="list_view">
                            <a class="btn-primary full-width" @click.stop="list_view = false">Tile View</a>
                        </div>
                        <template v-if="user_can_manage_downloads">
                            <div class="pr-1-xs">
                                <a class="btn-primary full-width" href="/downloads/tags">Manage Tags</a>
                            </div>
                            <div class="pr-1-xs">
                                <a class="btn-primary full-width" href="/downloads/create">Add New</a>
                            </div>
                            <div class="pr-1-xs">
                                <a class="btn-primary full-width" href="/downloads/statistics">Logs</a>
                            </div>
                        </template>
                    </div>
                  <div class="flex-xs">
                    <div @click.stop class="pt-1 pt-0-xs">
                      <div class="multi-select-input" @click.stop="tag_dropdown_open = !tag_dropdown_open" style="min-width:255px;">
                        <div class="multi-select-input-placeholder">
                          Filter ...
                          <div class="dropdown-icon">
                            <i class="fal fa-chevron-down"></i>
                          </div>
                        </div>
                        <div class="multi-select-input-inner" v-show="tag_dropdown_open">
                          <div class="multi-select-input-group">
                            <h1 class="input-group-title">Systems</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="system_type in epwin_system_types" v-show="system_type.label !== 'Spectrum' || (system_type.label === 'Spectrum' && logged_in_user.isSuperUser)">
                                <label>
                                  <input type="checkbox" name="selected_system_types" :value="system_type.id" v-model="selected_system_types">
                                  <span class="checkbox-label">{{ system_type.label }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="multi-select-input-group mt-3">
                            <h1 class="input-group-title">Types</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="type in content_upload_types">
                                <label>
                                  <input type="checkbox" name="types" :value="type.id" v-model="selected_type_ids">
                                  <span class="checkbox-label">{{ type.name }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                          <div class="multi-select-input-group mt-3">
                            <h1 class="input-group-title">Tags</h1>
                            <div class="checkboxes">
                              <div class="checkbox level-1" v-for="tag in tags">
                                <label>
                                  <input type="checkbox" name="tags" :value="tag.id" v-model="selected_tags">
                                  <span class="checkbox-label">{{ tag.name }}</span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pl-1 pt-1 pt-0-xs">
                      <input type="text" v-model="search_query" class="form-control" placeholder="Search..." style="min-width: 125px;">
                    </div>
                      <div class="pl-1 pt-1 pt-0-xs">
                          <select class="form-control" v-model="sort_by" style="min-width: 100px;">
                              <option value="">Sort ... </option>
                              <option value="date_desc"> Newest to Oldest </option>
                              <option value="date_asc"> Oldest to Newest </option>
                              <option value="alphabet_asc">A to Z</option>
                              <option value="alphabet_desc"> Z to A </option>
                          </select>
                      </div>
                  </div>
                </div>
        </div>
        <div class="box">
            <div class="box-content">
                <div v-show="selected_type_ids.includes(16) && logged_in_user.isCustomer" class="request-a-how-to-guide-banner">
                  <div>Can't find what you're looking&nbsp;for?</div><div><a @click.prevent="how_to_guide_enquiry_box_open = true" class="btn-primary-outline">Request a guide</a></div>
                </div>
                <div class="technical-uploads-list" v-show="content_uploads.length > 0" v-if="!list_view">
                    <div v-if="logged_in_user.temporary_login" class="transparent-overlay" @click="showTemporaryLoginModal()"></div>
                    <div class="technical-uploads-list-item" v-for="content_upload in content_uploads">
                        <div class="box _bordered">
                            <div>
                                <img :src="`${$aws_bucket_url}${content_upload.thumbnail_url}`" @error="imageFallbackIcon">
                            </div>
                            <div>
                                <div class="technical-uploads-list-item-name"> {{ content_upload.name }} </div>
                                <!-- **********
                                for debugging
                                ********** -->
                                <!--<div>-->
                                    <!--ACP Only: {{ content_upload.acp_only }}-->
                                <!--</div>-->
                                <!--<div>-->
                                    <!--Available: {{ content_upload.available_for_user }}-->
                                <!--</div>-->
                                <!--<div class="txt-danger mt-3 mb-3">-->
                                    <!--{{ content_upload.available_for_user_debug_string }}-->
                                <!--</div>-->
                                <div class="pt-2">
                                    <a class="btn-primary _sm" @click.stop.prevent="downloadItem(content_upload.id)" v-if="content_upload.type === 'file'">
                                        <strong>Download</strong>
                                    </a>
                                    <a class="btn-primary _sm" @click.stop.prevent="openVideo(content_upload)" v-if="content_upload.type === 'video'">
                                        <strong>Watch</strong>
                                    </a>
                                    <a class="btn-primary _sm" @click.stop.prevent="forward_download_box_open = true, forward_download_item_id = content_upload.id">
                                      <strong>Forward</strong>
                                    </a>
<!--                                    <div>-->
<!--                                      <span v-for="tag in content_upload.tags">{{ tag.name }}, </span>-->
<!--                                    </div>-->
                                    <div v-if="user_can_manage_downloads" class="technical-uploads-list-item-delete">
                                        <a @click.prevent="deleteItem(content_upload.id)">
                                            <i class="fal fa-trash-alt"></i>
                                        </a>
                                    </div>
                                    <div v-if="user_can_manage_downloads" class="technical-uploads-list-item-edit">
                                        <a :href="'/downloads/edit/' + content_upload.id">
                                            <i class="fal fa-pencil"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content-uploads-list-view" v-show="content_uploads.length > 0" v-if="list_view"  :class="{ 'user_can_manage_downloads' : user_can_manage_downloads }">
                    <div v-if="logged_in_user.temporary_login" class="transparent-overlay" @click="showTemporaryLoginModal()"></div>
                    <table class="table _lined">
                        <tbody>
                        <tr v-for="content_upload in content_uploads">
                            <td class="content-uploads-list-view-image">
                                <div>
                                    <img :src="`${$aws_bucket_url}${content_upload.thumbnail_url}`" @error="imageFallbackIcon">
                                </div>
                            </td>
                            <td class="content-uploads-list-view-name">
                                {{ content_upload.name }}
                            </td>
                            <td class="content-uploads-list-view-buttons">
                                <a @click.prevent="deleteItem(content_upload.id)" class="btn-danger" v-if="user_can_manage_downloads">
                                    <i class="fal fa-trash-alt"></i>
                                </a>
                                <a class="btn-primary" @click="downloadItem(content_upload.id)">
                                    <strong>Download</strong>
                                </a>
                                <a :href="'/downloads/edit/' + content_upload.id" class="btn-primary" v-if="user_can_manage_downloads">
                                    <i class="fal fa-pencil"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <template v-if="!loading && total_count > 0">
                    <div class="pagination-bar wrapper mb-3 mt-3">
                        <div class="row">
                            <div class="col">
                                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                    class="fa fa-caret-left"></i></a>
                                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                            </div>
                            <div class="col align-right">
                                <div class="mt-1 mb-1">
                                    {{ total_count }} results found
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
              <template v-if="!loading && total_count === 0">
                <strong class="block mt-3 p-3">
                  No Results Found
                </strong>
              </template>
            </div>
        </div>
    </div>
</template>

<script>
  import VideoEmbed from "../VideoEmbed";

  export default {
    components: {
      VideoEmbed,
    },
    props: [
        'logged_in_user',
        'user_can_manage_downloads',
        'selected_content_upload_types',
        'selected_content_upload_tags',
        'selected_epwin_system_type',
        'view_video_embed',
        'view_file_embed',
        'epwin_system_types',
    ],
    data() {
        return {
            search_query: '',
            selected_tags: [],
            selected_type_ids: [],
            selected_system_types: [],
            system_types: [],
            tags: [],
            content_upload_types: [],
            content_uploads: [],
            loading: true,
            tag_dropdown_open: false,
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            limit: 24,
            sort_by: '',
            list_view: false,
            video_box_open: false,
            open_video: {
              file_url: null,
              name: null,
            },
          file_box_open: false,
          open_file: {},
          how_to_guide_enquiry_box_open: false,
          how_to_guide_enquiry_message: '',
          sending_how_to_guide_enquiry: false,
          forward_download_box_open: false,
          forward_download_item_id: null,
          sending_forward_download_email: false,
          forwarding_email: null,
        };
    },
    async mounted() {
        await this.loadTags();
        await this.loadContentUploadTypes();
        await this.loadSystemTypes();

        const has_system = this.selected_epwin_system_type.length > 0;
        const has_types = this.selected_content_upload_types.length > 0;
        const has_tags = this.selected_content_upload_tags.length > 0;

        if(has_system) {
          this.selected_system_types.push(this.selected_epwin_system_type[0]);
        }

        if(has_types) {
          this.selected_type_ids = this.selected_content_upload_types;
        }

        if(has_tags) {
          this.selected_tags = this.selected_content_upload_tags;
        }

        if(!has_system && !has_types && !has_tags) {
          this.loadContentUploads();
        }

        if(this.view_video_embed !== 'none') {
          this.openVideo(this.view_video_embed);
        }

        if(this.view_file_embed !== 'none') {
          this.openFile(this.view_file_embed);
        }

    },
    methods: {
        loadTags() {
            axios.get('/downloads/getTags').then((response) => {
                this.tags = response.data;
            });
        },
        loadContentUploadTypes() {
          axios.get('/downloads/getContentUploadTypes').then((response) => {
            this.content_upload_types = response.data;
          });
        },
        loadSystemTypes() {
            axios.get('/downloads/getSystemTypes').then((response) => {
                this.system_types = response.data;
            });
        },
        loadContentUploads: _.debounce(function() {
          this.loading = true;
          axios.post('/downloads/getUploads', {
            selected_tags: this.selected_tags,
            selected_type_ids: this.selected_type_ids,
            selected_system_types: this.selected_system_types,
            search_query: this.search_query,
            sort_by: this.sort_by,
            page_number: this.current_page,
            limit: this.limit,
          }).then((response) => {
            this.content_uploads = response.data.data;
            this.total_count = response.data.total;
            this.total_pages = response.data.last_page;
            this.loading = false;
          });
        }, 250),
        deleteItem(id) {
            Swal.fire({
                title: 'Are you sure you want to remove this item?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.loading = true;
                    axios.post('/downloads/delete', {
                        'content_upload_id': id,
                    }).then((response) => {
                        this.current_page = 1;
                        this.loadContentUploads();
                        Swal.fire({
                            title: 'Upload Deleted',
                            icon: 'success',
                        });
                    });
                }
            });
        },
        isTagSelected(tag) {
            return this.selected_tags.filter(selected_tag => selected_tag === tag.id).length > 0;
        },
        downloadItem(item_id) {
          if(this.logged_in_user.temporary_login) {
            this.showTemporaryLoginModal();
            return;
          }

          gtag('event', 'item_downloaded', {
            'event_category': 'downloads',
            'event_label': 'Item downloaded',
            'value': item_id,
          });
          this.file_box_open = false;
          this.open_file = {};
          axios.get( `/downloads/download-item/${item_id}`).then((response) => {
            window.location.href = response.data;
          });
        },
        openVideo(video) {
          if(this.logged_in_user.temporary_login) {
            this.showTemporaryLoginModal();
            return;
          }

          if(!video.available_for_user) {
            Swal.fire({
              title: 'Permission Denied',
              icon: 'error',
              text: 'You do not have permission to view this file.'
            });
            return;
          }

          axios.post('/activity-logs/createActivityLogFromRequest', {
            'activity_log_category_id': 2,
            'description': `"${video.name}" Video Viewed`,
          }).then((response) => {
            gtag('event', 'video_watched', {
              'event_category': 'downloads',
              'event_label': 'Video Watched',
              'value': video.name,
            });
            this.file_box_open = false;
            this.open_file = {};
            this.open_video = video;
            this.video_box_open = true;
          });
        },
        openFile(file) {

          if(this.logged_in_user.temporary_login) {
            this.showTemporaryLoginModal();
            return;
          }

          if(!file.available_for_user) {
            Swal.fire({
              title: 'Permission Denied',
              icon: 'error',
              text: 'You do not have permission to view this file.'
            });
            return;
          }

          axios.post('/activity-logs/createActivityLogFromRequest', {
            'activity_log_category_id': 2,
            'description': `"${file.name}" Item Viewed`,
          }).then((response) => {
            this.file_box_open = true;
            gtag('event', 'item_viewed', {
              'event_category': 'downloads',
              'event_label': 'Item Viewed',
              'value': file.name,
            });
            this.open_file = file;
          });

        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadContentUploads();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadContentUploads();
        },
      imageFallbackIcon(event) {
          event.target.src = '/images/content-uploads-thumbnail-fallback-icon.png';
      },
      sendHowToGuideEnquiry() {

        if(this.how_to_guide_enquiry_message === '') {
          Swal.fire({
            title: 'Please enter a message',
            icon: 'error',
          });
          return;
        }

        this.how_to_guide_enquiry_box_open = false;
        this.sending_how_to_guide_enquiry = true;
        axios.post('/enquiry/send', {
          'enquiry_type_id': 25,
          'message': this.how_to_guide_enquiry_message,
        }).then((response) => {

          gtag('event', 'enquiry_made', {
            'event_category': 'enquiries',
            'event_label': 'How to Guide Request',
            'value': 'How to Guide Request',
          });

          this.sending_how_to_guide_enquiry = false;
          Swal.fire({
            title: 'Request Sent',
            icon: 'success',
            text: 'Your request has been sent, you will be sent a notification when you receive a reply.'
          });
        });
      },
      sendForwardDownloadEmail() {

        if(this.logged_in_user.temporary_login) {
          this.showTemporaryLoginModal();
          return;
        }

        const validationErrors = Validate({
          email: this.forwarding_email,
        }, {
          email: {
            presence: {
              allowEmpty: false,
            },
            email: true,
          },
        });

        if (validationErrors) {
          Swal.fire({
            title: 'Invalid email address',
            icon: 'error',
          });
          return;
        }

        this.forward_download_box_open = false;
        this.sending_forward_download_email = true;
        axios.post('/downloads/forward-item', {
          'item_id': this.forward_download_item_id,
          'forwarding_email': this.forwarding_email,
        }).then((response) => {

          gtag('event', 'item_forwarded', {
            'event_category': 'downloads',
            'event_label': 'Item Forwarded',
            'value': 'Item Forwarded',
          });

          this.sending_forward_download_email = false;
          Swal.fire({
            title: 'Item Sent',
            icon: 'success',
            text: 'An email has been sent to ' + this.forwarding_email + ' with this item.'
          });
        });
      },
      showTemporaryLoginModal() {
        Swal.fire({
          title: 'Temporary Account',
          icon: 'warning',
          text: 'You have a temporary account. Access to downloads is restricted.'
        });
      },
    },
    watch: {
        search_query() {
            this.current_page = 1;
            this.loadContentUploads();
        },
        selected_tags() {
            this.current_page = 1;
            this.loadContentUploads();
        },
        selected_type_ids() {
          this.current_page = 1;
          this.loadContentUploads();
        },
        selected_system_types() {
            this.current_page = 1;
            this.loadContentUploads();
        },
        sort_by() {
          this.current_page = 1;
          this.loadContentUploads();
        },
    },
};
</script>
